import React, {useEffect, useState} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import useSeries from 'hooks/useSeries'

import PrivatePage from "components/PrivatePage";
import SeriePreview from "components/SeriePreview";

const SeriesGrid = ({series}) => {
  return (
  <div className="columns is-multiline">
  {
    series.map((serie) =>
      <SeriePreview {...serie} />
    )
  }
  </div>
  )
}

const Series = ({navbarProps}) => {
  const series = useSeries();
  series.sort((s1, s2) => s2.is_on_going - s1.is_on_going)
  const [search, setSearch] = useState(null);
  const [filteredSeries, setFilteredSeries] = useState(series);
  useEffect(() => {
    setFilteredSeries(series)
  }, [series])
  useEffect(() => {
    setFilteredSeries(series.filter((serie) => !search || serie.name.toLowerCase().includes(search) || serie.tags.join(',').toLowerCase().includes(search)))
  }, [search])
  return (
  <PrivatePage navbarProps={navbarProps}>
    <div className="container p-4">
      <h1 className="title is-1">
        Séries
      </h1>
      <div className="control has-icons-left">
        <input
          type="text"
          className="input is-medium"
          placeholder="Rechercher une série"
          value={search}
          onChange={(e) => setSearch(e.currentTarget.value.toLowerCase())}/>
        <span className="icon is-medium is-left">
          <FontAwesomeIcon icon={faSearch}/>
        </span>
      </div>
      <hr />
      <SeriesGrid series={filteredSeries} />
    </div>
  </PrivatePage>
  )
}

export default Series;